/* =========================================================
   RAMADAN 2026 — SINGLE SOURCE OF TRUTH
   ---------------------------------------------------------
   Day-level keys legend:
   g → gregorianDate (YYYY-MM-DD)
   h → hijriDate (display)
   r → rozaNumber
   a → ashra (1 | 2 | 3 | 0)
   s → sehriEnds (HH:mm, 24h)
   i → iftarTime (HH:mm, 24h)
   e → isEid
   ========================================================= */

export type CityKey =
  | "islamabad"
  | "lahore"
  | "karachi"
  | "multan"
  | "quetta"
  | "gilgit";

export interface RamadanDayShort {
  g: string;
  h: string;
  r: number;
  a: 1 | 2 | 3 | 0;
  s: string;
  i: string;
  e: boolean;
}

export interface CityRamadanTimings {
  cityKey: CityKey;
  cityName: string;
  timezone: string;
  days: RamadanDayShort[];
}

export const RAMADAN_DISCLAIMER =
  "Sehr aur Iftar ke timings mein 1 minute ka farq ho sakta hai. Barah-e-karam apni qareebi masjid ki ittila par amal karein.";

export const RAMADAN_2026: Record<CityKey, CityRamadanTimings> = {
  "karachi": {
    "cityKey": "karachi",
    "cityName": "Karachi",
    "timezone": "Asia/Karachi",
    "days": [
      {
        "g": "2026-02-19",
        "h": "1 Ramadan",
        "r": 1,
        "a": 1,
        "s": "05:47",
        "i": "18:28",
        "e": false
      },
      {
        "g": "2026-02-20",
        "h": "2 Ramadan",
        "r": 2,
        "a": 1,
        "s": "05:46",
        "i": "18:29",
        "e": false
      },
      {
        "g": "2026-02-21",
        "h": "3 Ramadan",
        "r": 3,
        "a": 1,
        "s": "05:45",
        "i": "18:29",
        "e": false
      },
      {
        "g": "2026-02-22",
        "h": "4 Ramadan",
        "r": 4,
        "a": 1,
        "s": "05:44",
        "i": "18:30",
        "e": false
      },
      {
        "g": "2026-02-23",
        "h": "5 Ramadan",
        "r": 5,
        "a": 1,
        "s": "05:44",
        "i": "18:30",
        "e": false
      },
      {
        "g": "2026-02-24",
        "h": "6 Ramadan",
        "r": 6,
        "a": 1,
        "s": "05:43",
        "i": "18:31",
        "e": false
      },
      {
        "g": "2026-02-25",
        "h": "7 Ramadan",
        "r": 7,
        "a": 1,
        "s": "05:42",
        "i": "18:32",
        "e": false
      },
      {
        "g": "2026-02-26",
        "h": "8 Ramadan",
        "r": 8,
        "a": 1,
        "s": "05:41",
        "i": "18:32",
        "e": false
      },
      {
        "g": "2026-02-27",
        "h": "9 Ramadan",
        "r": 9,
        "a": 1,
        "s": "05:40",
        "i": "18:33",
        "e": false
      },
      {
        "g": "2026-02-28",
        "h": "10 Ramadan",
        "r": 10,
        "a": 1,
        "s": "05:40",
        "i": "18:33",
        "e": false
      },
      {
        "g": "2026-03-01",
        "h": "11 Ramadan",
        "r": 11,
        "a": 2,
        "s": "05:39",
        "i": "18:34",
        "e": false
      },
      {
        "g": "2026-03-02",
        "h": "12 Ramadan",
        "r": 12,
        "a": 2,
        "s": "05:38",
        "i": "18:34",
        "e": false
      },
      {
        "g": "2026-03-03",
        "h": "13 Ramadan",
        "r": 13,
        "a": 2,
        "s": "05:37",
        "i": "18:35",
        "e": false
      },
      {
        "g": "2026-03-04",
        "h": "14 Ramadan",
        "r": 14,
        "a": 2,
        "s": "05:36",
        "i": "18:35",
        "e": false
      },
      {
        "g": "2026-03-05",
        "h": "15 Ramadan",
        "r": 15,
        "a": 2,
        "s": "05:35",
        "i": "18:36",
        "e": false
      },
      {
        "g": "2026-03-06",
        "h": "16 Ramadan",
        "r": 16,
        "a": 2,
        "s": "05:34",
        "i": "18:36",
        "e": false
      },
      {
        "g": "2026-03-07",
        "h": "17 Ramadan",
        "r": 17,
        "a": 2,
        "s": "05:33",
        "i": "18:37",
        "e": false
      },
      {
        "g": "2026-03-08",
        "h": "18 Ramadan",
        "r": 18,
        "a": 2,
        "s": "05:32",
        "i": "18:37",
        "e": false
      },
      {
        "g": "2026-03-09",
        "h": "19 Ramadan",
        "r": 19,
        "a": 2,
        "s": "05:31",
        "i": "18:38",
        "e": false
      },
      {
        "g": "2026-03-10",
        "h": "20 Ramadan",
        "r": 20,
        "a": 2,
        "s": "05:30",
        "i": "18:38",
        "e": false
      },
      {
        "g": "2026-03-11",
        "h": "21 Ramadan",
        "r": 21,
        "a": 3,
        "s": "05:29",
        "i": "18:39",
        "e": false
      },
      {
        "g": "2026-03-12",
        "h": "22 Ramadan",
        "r": 22,
        "a": 3,
        "s": "05:28",
        "i": "18:39",
        "e": false
      },
      {
        "g": "2026-03-13",
        "h": "23 Ramadan",
        "r": 23,
        "a": 3,
        "s": "05:27",
        "i": "18:40",
        "e": false
      },
      {
        "g": "2026-03-14",
        "h": "24 Ramadan",
        "r": 24,
        "a": 3,
        "s": "05:26",
        "i": "18:40",
        "e": false
      },
      {
        "g": "2026-03-15",
        "h": "25 Ramadan",
        "r": 25,
        "a": 3,
        "s": "05:25",
        "i": "18:40",
        "e": false
      },
      {
        "g": "2026-03-16",
        "h": "26 Ramadan",
        "r": 26,
        "a": 3,
        "s": "05:24",
        "i": "18:41",
        "e": false
      },
      {
        "g": "2026-03-17",
        "h": "27 Ramadan",
        "r": 27,
        "a": 3,
        "s": "05:23",
        "i": "18:41",
        "e": false
      },
      {
        "g": "2026-03-18",
        "h": "28 Ramadan",
        "r": 28,
        "a": 3,
        "s": "05:22",
        "i": "18:42",
        "e": false
      },
      {
        "g": "2026-03-19",
        "h": "29 Ramadan",
        "r": 29,
        "a": 3,
        "s": "05:21",
        "i": "18:42",
        "e": false
      },
      {
        "g": "2026-03-20",
        "h": "30 Ramadan",
        "r": 30,
        "a": 3,
        "s": "05:20",
        "i": "18:43",
        "e": false
      },
      {
        "g": "2026-03-21",
        "h": "1 Shawwal",
        "r": 0,
        "a": 0,
        "s": "05:19",
        "i": "18:43",
        "e": true
      },
      {
        "g": "2026-03-22",
        "h": "2 Shawwal",
        "r": 0,
        "a": 0,
        "s": "05:18",
        "i": "18:44",
        "e": false
      },
      {
        "g": "2026-03-23",
        "h": "3 Shawwal",
        "r": 0,
        "a": 0,
        "s": "05:17",
        "i": "18:44",
        "e": false
      },
      {
        "g": "2026-03-24",
        "h": "4 Shawwal",
        "r": 0,
        "a": 0,
        "s": "05:16",
        "i": "18:44",
        "e": false
      },
      {
        "g": "2026-03-25",
        "h": "5 Shawwal",
        "r": 0,
        "a": 0,
        "s": "05:15",
        "i": "18:45",
        "e": false
      },
      {
        "g": "2026-03-26",
        "h": "6 Shawwal",
        "r": 0,
        "a": 0,
        "s": "05:13",
        "i": "18:45",
        "e": false
      },
      {
        "g": "2026-03-27",
        "h": "7 Shawwal",
        "r": 0,
        "a": 0,
        "s": "05:12",
        "i": "18:46",
        "e": false
      },
      {
        "g": "2026-03-28",
        "h": "8 Shawwal",
        "r": 0,
        "a": 0,
        "s": "05:11",
        "i": "18:46",
        "e": false
      },
      {
        "g": "2026-03-29",
        "h": "9 Shawwal",
        "r": 0,
        "a": 0,
        "s": "05:10",
        "i": "18:47",
        "e": false
      },
      {
        "g": "2026-03-30",
        "h": "10 Shawwal",
        "r": 0,
        "a": 0,
        "s": "05:09",
        "i": "18:47",
        "e": false
      },
      {
        "g": "2026-03-31",
        "h": "11 Shawwal",
        "r": 0,
        "a": 0,
        "s": "05:08",
        "i": "18:47",
        "e": false
      }
    ]
  },
  "lahore": {
    "cityKey": "lahore",
    "cityName": "Lahore",
    "timezone": "Asia/Karachi",
    "days": [
      {
        "g": "2026-02-19",
        "h": "1 Ramadan",
        "r": 1,
        "a": 1,
        "s": "05:19",
        "i": "17:53",
        "e": false
      },
      {
        "g": "2026-02-20",
        "h": "2 Ramadan",
        "r": 2,
        "a": 1,
        "s": "05:18",
        "i": "17:53",
        "e": false
      },
      {
        "g": "2026-02-21",
        "h": "3 Ramadan",
        "r": 3,
        "a": 1,
        "s": "05:17",
        "i": "17:54",
        "e": false
      },
      {
        "g": "2026-02-22",
        "h": "4 Ramadan",
        "r": 4,
        "a": 1,
        "s": "05:16",
        "i": "17:55",
        "e": false
      },
      {
        "g": "2026-02-23",
        "h": "5 Ramadan",
        "r": 5,
        "a": 1,
        "s": "05:16",
        "i": "17:56",
        "e": false
      },
      {
        "g": "2026-02-24",
        "h": "6 Ramadan",
        "r": 6,
        "a": 1,
        "s": "05:14",
        "i": "17:57",
        "e": false
      },
      {
        "g": "2026-02-25",
        "h": "7 Ramadan",
        "r": 7,
        "a": 1,
        "s": "05:13",
        "i": "17:57",
        "e": false
      },
      {
        "g": "2026-02-26",
        "h": "8 Ramadan",
        "r": 8,
        "a": 1,
        "s": "05:12",
        "i": "17:58",
        "e": false
      },
      {
        "g": "2026-02-27",
        "h": "9 Ramadan",
        "r": 9,
        "a": 1,
        "s": "05:11",
        "i": "17:59",
        "e": false
      },
      {
        "g": "2026-02-28",
        "h": "10 Ramadan",
        "r": 10,
        "a": 1,
        "s": "05:10",
        "i": "18:00",
        "e": false
      },
      {
        "g": "2026-03-01",
        "h": "11 Ramadan",
        "r": 11,
        "a": 2,
        "s": "05:09",
        "i": "18:00",
        "e": false
      },
      {
        "g": "2026-03-02",
        "h": "12 Ramadan",
        "r": 12,
        "a": 2,
        "s": "05:08",
        "i": "18:01",
        "e": false
      },
      {
        "g": "2026-03-03",
        "h": "13 Ramadan",
        "r": 13,
        "a": 2,
        "s": "05:07",
        "i": "18:02",
        "e": false
      },
      {
        "g": "2026-03-04",
        "h": "14 Ramadan",
        "r": 14,
        "a": 2,
        "s": "05:06",
        "i": "18:03",
        "e": false
      },
      {
        "g": "2026-03-05",
        "h": "15 Ramadan",
        "r": 15,
        "a": 2,
        "s": "05:05",
        "i": "18:03",
        "e": false
      },
      {
        "g": "2026-03-06",
        "h": "16 Ramadan",
        "r": 16,
        "a": 2,
        "s": "05:03",
        "i": "18:04",
        "e": false
      },
      {
        "g": "2026-03-07",
        "h": "17 Ramadan",
        "r": 17,
        "a": 2,
        "s": "05:02",
        "i": "18:05",
        "e": false
      },
      {
        "g": "2026-03-08",
        "h": "18 Ramadan",
        "r": 18,
        "a": 2,
        "s": "05:01",
        "i": "18:06",
        "e": false
      },
      {
        "g": "2026-03-09",
        "h": "19 Ramadan",
        "r": 19,
        "a": 2,
        "s": "05:00",
        "i": "18:06",
        "e": false
      },
      {
        "g": "2026-03-10",
        "h": "20 Ramadan",
        "r": 20,
        "a": 2,
        "s": "04:59",
        "i": "18:07",
        "e": false
      },
      {
        "g": "2026-03-11",
        "h": "21 Ramadan",
        "r": 21,
        "a": 3,
        "s": "04:57",
        "i": "18:08",
        "e": false
      },
      {
        "g": "2026-03-12",
        "h": "22 Ramadan",
        "r": 22,
        "a": 3,
        "s": "04:56",
        "i": "18:08",
        "e": false
      },
      {
        "g": "2026-03-13",
        "h": "23 Ramadan",
        "r": 23,
        "a": 3,
        "s": "04:55",
        "i": "18:09",
        "e": false
      },
      {
        "g": "2026-03-14",
        "h": "24 Ramadan",
        "r": 24,
        "a": 3,
        "s": "04:54",
        "i": "18:10",
        "e": false
      },
      {
        "g": "2026-03-15",
        "h": "25 Ramadan",
        "r": 25,
        "a": 3,
        "s": "04:52",
        "i": "18:10",
        "e": false
      },
      {
        "g": "2026-03-16",
        "h": "26 Ramadan",
        "r": 26,
        "a": 3,
        "s": "04:51",
        "i": "18:11",
        "e": false
      },
      {
        "g": "2026-03-17",
        "h": "27 Ramadan",
        "r": 27,
        "a": 3,
        "s": "04:50",
        "i": "18:12",
        "e": false
      },
      {
        "g": "2026-03-18",
        "h": "28 Ramadan",
        "r": 28,
        "a": 3,
        "s": "04:48",
        "i": "18:13",
        "e": false
      },
      {
        "g": "2026-03-19",
        "h": "29 Ramadan",
        "r": 29,
        "a": 3,
        "s": "04:47",
        "i": "18:13",
        "e": false
      },
      {
        "g": "2026-03-20",
        "h": "30 Ramadan",
        "r": 30,
        "a": 3,
        "s": "04:46",
        "i": "18:14",
        "e": false
      },
      {
        "g": "2026-03-21",
        "h": "1 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:44",
        "i": "18:15",
        "e": true
      },
      {
        "g": "2026-03-22",
        "h": "2 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:43",
        "i": "18:15",
        "e": false
      },
      {
        "g": "2026-03-23",
        "h": "3 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:42",
        "i": "18:16",
        "e": false
      },
      {
        "g": "2026-03-24",
        "h": "4 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:40",
        "i": "18:17",
        "e": false
      },
      {
        "g": "2026-03-25",
        "h": "5 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:39",
        "i": "18:17",
        "e": false
      },
      {
        "g": "2026-03-26",
        "h": "6 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:38",
        "i": "18:18",
        "e": false
      },
      {
        "g": "2026-03-27",
        "h": "7 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:36",
        "i": "18:19",
        "e": false
      },
      {
        "g": "2026-03-28",
        "h": "8 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:35",
        "i": "18:19",
        "e": false
      },
      {
        "g": "2026-03-29",
        "h": "9 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:34",
        "i": "18:20",
        "e": false
      },
      {
        "g": "2026-03-30",
        "h": "10 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:32",
        "i": "18:21",
        "e": false
      },
      {
        "g": "2026-03-31",
        "h": "11 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:31",
        "i": "18:21",
        "e": false
      }
    ]
  },
  "islamabad": {
    "cityKey": "islamabad",
    "cityName": "Islamabad",
    "timezone": "Asia/Karachi",
    "days": [
      {
        "g": "2026-02-19",
        "h": "1 Ramadan",
        "r": 1,
        "a": 1,
        "s": "05:25",
        "i": "17:56",
        "e": false
      },
      {
        "g": "2026-02-20",
        "h": "2 Ramadan",
        "r": 2,
        "a": 1,
        "s": "05:24",
        "i": "17:56",
        "e": false
      },
      {
        "g": "2026-02-21",
        "h": "3 Ramadan",
        "r": 3,
        "a": 1,
        "s": "05:23",
        "i": "17:57",
        "e": false
      },
      {
        "g": "2026-02-22",
        "h": "4 Ramadan",
        "r": 4,
        "a": 1,
        "s": "05:22",
        "i": "17:58",
        "e": false
      },
      {
        "g": "2026-02-23",
        "h": "5 Ramadan",
        "r": 5,
        "a": 1,
        "s": "05:21",
        "i": "17:59",
        "e": false
      },
      {
        "g": "2026-02-24",
        "h": "6 Ramadan",
        "r": 6,
        "a": 1,
        "s": "05:20",
        "i": "18:00",
        "e": false
      },
      {
        "g": "2026-02-25",
        "h": "7 Ramadan",
        "r": 7,
        "a": 1,
        "s": "05:19",
        "i": "18:01",
        "e": false
      },
      {
        "g": "2026-02-26",
        "h": "8 Ramadan",
        "r": 8,
        "a": 1,
        "s": "05:18",
        "i": "18:02",
        "e": false
      },
      {
        "g": "2026-02-27",
        "h": "9 Ramadan",
        "r": 9,
        "a": 1,
        "s": "05:16",
        "i": "18:03",
        "e": false
      },
      {
        "g": "2026-02-28",
        "h": "10 Ramadan",
        "r": 10,
        "a": 1,
        "s": "05:15",
        "i": "18:03",
        "e": false
      },
      {
        "g": "2026-03-01",
        "h": "11 Ramadan",
        "r": 11,
        "a": 2,
        "s": "05:14",
        "i": "18:04",
        "e": false
      },
      {
        "g": "2026-03-02",
        "h": "12 Ramadan",
        "r": 12,
        "a": 2,
        "s": "05:13",
        "i": "18:05",
        "e": false
      },
      {
        "g": "2026-03-03",
        "h": "13 Ramadan",
        "r": 13,
        "a": 2,
        "s": "05:12",
        "i": "18:06",
        "e": false
      },
      {
        "g": "2026-03-04",
        "h": "14 Ramadan",
        "r": 14,
        "a": 2,
        "s": "05:10",
        "i": "18:07",
        "e": false
      },
      {
        "g": "2026-03-05",
        "h": "15 Ramadan",
        "r": 15,
        "a": 2,
        "s": "05:09",
        "i": "18:08",
        "e": false
      },
      {
        "g": "2026-03-06",
        "h": "16 Ramadan",
        "r": 16,
        "a": 2,
        "s": "05:08",
        "i": "18:08",
        "e": false
      },
      {
        "g": "2026-03-07",
        "h": "17 Ramadan",
        "r": 17,
        "a": 2,
        "s": "05:07",
        "i": "18:09",
        "e": false
      },
      {
        "g": "2026-03-08",
        "h": "18 Ramadan",
        "r": 18,
        "a": 2,
        "s": "05:05",
        "i": "18:10",
        "e": false
      },
      {
        "g": "2026-03-09",
        "h": "19 Ramadan",
        "r": 19,
        "a": 2,
        "s": "05:04",
        "i": "18:11",
        "e": false
      },
      {
        "g": "2026-03-10",
        "h": "20 Ramadan",
        "r": 20,
        "a": 2,
        "s": "05:03",
        "i": "18:12",
        "e": false
      },
      {
        "g": "2026-03-11",
        "h": "21 Ramadan",
        "r": 21,
        "a": 3,
        "s": "05:01",
        "i": "18:12",
        "e": false
      },
      {
        "g": "2026-03-12",
        "h": "22 Ramadan",
        "r": 22,
        "a": 3,
        "s": "05:00",
        "i": "18:13",
        "e": false
      },
      {
        "g": "2026-03-13",
        "h": "23 Ramadan",
        "r": 23,
        "a": 3,
        "s": "04:59",
        "i": "18:14",
        "e": false
      },
      {
        "g": "2026-03-14",
        "h": "24 Ramadan",
        "r": 24,
        "a": 3,
        "s": "04:57",
        "i": "18:15",
        "e": false
      },
      {
        "g": "2026-03-15",
        "h": "25 Ramadan",
        "r": 25,
        "a": 3,
        "s": "04:56",
        "i": "18:15",
        "e": false
      },
      {
        "g": "2026-03-16",
        "h": "26 Ramadan",
        "r": 26,
        "a": 3,
        "s": "04:55",
        "i": "18:16",
        "e": false
      },
      {
        "g": "2026-03-17",
        "h": "27 Ramadan",
        "r": 27,
        "a": 3,
        "s": "04:53",
        "i": "18:17",
        "e": false
      },
      {
        "g": "2026-03-18",
        "h": "28 Ramadan",
        "r": 28,
        "a": 3,
        "s": "04:52",
        "i": "18:18",
        "e": false
      },
      {
        "g": "2026-03-19",
        "h": "29 Ramadan",
        "r": 29,
        "a": 3,
        "s": "04:50",
        "i": "18:19",
        "e": false
      },
      {
        "g": "2026-03-20",
        "h": "30 Ramadan",
        "r": 30,
        "a": 3,
        "s": "04:49",
        "i": "18:19",
        "e": false
      },
      {
        "g": "2026-03-21",
        "h": "1 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:48",
        "i": "18:20",
        "e": true
      },
      {
        "g": "2026-03-22",
        "h": "2 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:46",
        "i": "18:21",
        "e": false
      },
      {
        "g": "2026-03-23",
        "h": "3 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:45",
        "i": "18:22",
        "e": false
      },
      {
        "g": "2026-03-24",
        "h": "4 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:43",
        "i": "18:22",
        "e": false
      },
      {
        "g": "2026-03-25",
        "h": "5 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:42",
        "i": "18:23",
        "e": false
      },
      {
        "g": "2026-03-26",
        "h": "6 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:40",
        "i": "18:24",
        "e": false
      },
      {
        "g": "2026-03-27",
        "h": "7 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:39",
        "i": "18:25",
        "e": false
      },
      {
        "g": "2026-03-28",
        "h": "8 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:37",
        "i": "18:25",
        "e": false
      },
      {
        "g": "2026-03-29",
        "h": "9 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:36",
        "i": "18:26",
        "e": false
      },
      {
        "g": "2026-03-30",
        "h": "10 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:34",
        "i": "18:27",
        "e": false
      },
      {
        "g": "2026-03-31",
        "h": "11 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:33",
        "i": "18:28",
        "e": false
      }
    ]
  },
  "multan": {
    "cityKey": "multan",
    "cityName": "Multan",
    "timezone": "Asia/Karachi",
    "days": [
      {
        "g": "2026-02-19",
        "h": "1 Ramadan",
        "r": 1,
        "a": 1,
        "s": "05:31",
        "i": "18:06",
        "e": false
      },
      {
        "g": "2026-02-20",
        "h": "2 Ramadan",
        "r": 2,
        "a": 1,
        "s": "05:30",
        "i": "18:06",
        "e": false
      },
      {
        "g": "2026-02-21",
        "h": "3 Ramadan",
        "r": 3,
        "a": 1,
        "s": "05:29",
        "i": "18:07",
        "e": false
      },
      {
        "g": "2026-02-22",
        "h": "4 Ramadan",
        "r": 4,
        "a": 1,
        "s": "05:28",
        "i": "18:08",
        "e": false
      },
      {
        "g": "2026-02-23",
        "h": "5 Ramadan",
        "r": 5,
        "a": 1,
        "s": "05:27",
        "i": "18:09",
        "e": false
      },
      {
        "g": "2026-02-24",
        "h": "6 Ramadan",
        "r": 6,
        "a": 1,
        "s": "05:26",
        "i": "18:09",
        "e": false
      },
      {
        "g": "2026-02-25",
        "h": "7 Ramadan",
        "r": 7,
        "a": 1,
        "s": "05:25",
        "i": "18:10",
        "e": false
      },
      {
        "g": "2026-02-26",
        "h": "8 Ramadan",
        "r": 8,
        "a": 1,
        "s": "05:24",
        "i": "18:11",
        "e": false
      },
      {
        "g": "2026-02-27",
        "h": "9 Ramadan",
        "r": 9,
        "a": 1,
        "s": "05:23",
        "i": "18:11",
        "e": false
      },
      {
        "g": "2026-02-28",
        "h": "10 Ramadan",
        "r": 10,
        "a": 1,
        "s": "05:22",
        "i": "18:12",
        "e": false
      },
      {
        "g": "2026-03-01",
        "h": "11 Ramadan",
        "r": 11,
        "a": 2,
        "s": "05:21",
        "i": "18:13",
        "e": false
      },
      {
        "g": "2026-03-02",
        "h": "12 Ramadan",
        "r": 12,
        "a": 2,
        "s": "05:20",
        "i": "18:14",
        "e": false
      },
      {
        "g": "2026-03-03",
        "h": "13 Ramadan",
        "r": 13,
        "a": 2,
        "s": "05:19",
        "i": "18:14",
        "e": false
      },
      {
        "g": "2026-03-04",
        "h": "14 Ramadan",
        "r": 14,
        "a": 2,
        "s": "05:18",
        "i": "18:15",
        "e": false
      },
      {
        "g": "2026-03-05",
        "h": "15 Ramadan",
        "r": 15,
        "a": 2,
        "s": "05:17",
        "i": "18:16",
        "e": false
      },
      {
        "g": "2026-03-06",
        "h": "16 Ramadan",
        "r": 16,
        "a": 2,
        "s": "05:15",
        "i": "18:16",
        "e": false
      },
      {
        "g": "2026-03-07",
        "h": "17 Ramadan",
        "r": 17,
        "a": 2,
        "s": "05:14",
        "i": "18:17",
        "e": false
      },
      {
        "g": "2026-03-08",
        "h": "18 Ramadan",
        "r": 18,
        "a": 2,
        "s": "05:13",
        "i": "18:18",
        "e": false
      },
      {
        "g": "2026-03-09",
        "h": "19 Ramadan",
        "r": 19,
        "a": 2,
        "s": "05:12",
        "i": "18:18",
        "e": false
      },
      {
        "g": "2026-03-10",
        "h": "20 Ramadan",
        "r": 20,
        "a": 2,
        "s": "05:11",
        "i": "18:19",
        "e": false
      },
      {
        "g": "2026-03-11",
        "h": "21 Ramadan",
        "r": 21,
        "a": 3,
        "s": "05:10",
        "i": "18:20",
        "e": false
      },
      {
        "g": "2026-03-12",
        "h": "22 Ramadan",
        "r": 22,
        "a": 3,
        "s": "05:08",
        "i": "18:20",
        "e": false
      },
      {
        "g": "2026-03-13",
        "h": "23 Ramadan",
        "r": 23,
        "a": 3,
        "s": "05:07",
        "i": "18:21",
        "e": false
      },
      {
        "g": "2026-03-14",
        "h": "24 Ramadan",
        "r": 24,
        "a": 3,
        "s": "05:06",
        "i": "18:22",
        "e": false
      },
      {
        "g": "2026-03-15",
        "h": "25 Ramadan",
        "r": 25,
        "a": 3,
        "s": "05:05",
        "i": "18:22",
        "e": false
      },
      {
        "g": "2026-03-16",
        "h": "26 Ramadan",
        "r": 26,
        "a": 3,
        "s": "05:04",
        "i": "18:23",
        "e": false
      },
      {
        "g": "2026-03-17",
        "h": "27 Ramadan",
        "r": 27,
        "a": 3,
        "s": "05:02",
        "i": "18:23",
        "e": false
      },
      {
        "g": "2026-03-18",
        "h": "28 Ramadan",
        "r": 28,
        "a": 3,
        "s": "05:01",
        "i": "18:24",
        "e": false
      },
      {
        "g": "2026-03-19",
        "h": "29 Ramadan",
        "r": 29,
        "a": 3,
        "s": "05:00",
        "i": "18:25",
        "e": false
      },
      {
        "g": "2026-03-20",
        "h": "30 Ramadan",
        "r": 30,
        "a": 3,
        "s": "04:59",
        "i": "18:25",
        "e": false
      },
      {
        "g": "2026-03-21",
        "h": "1 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:57",
        "i": "18:26",
        "e": true
      },
      {
        "g": "2026-03-22",
        "h": "2 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:56",
        "i": "18:27",
        "e": false
      },
      {
        "g": "2026-03-23",
        "h": "3 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:55",
        "i": "18:27",
        "e": false
      },
      {
        "g": "2026-03-24",
        "h": "4 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:53",
        "i": "18:28",
        "e": false
      },
      {
        "g": "2026-03-25",
        "h": "5 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:52",
        "i": "18:28",
        "e": false
      },
      {
        "g": "2026-03-26",
        "h": "6 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:51",
        "i": "18:29",
        "e": false
      },
      {
        "g": "2026-03-27",
        "h": "7 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:49",
        "i": "18:30",
        "e": false
      },
      {
        "g": "2026-03-28",
        "h": "8 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:48",
        "i": "18:30",
        "e": false
      },
      {
        "g": "2026-03-29",
        "h": "9 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:47",
        "i": "18:31",
        "e": false
      },
      {
        "g": "2026-03-30",
        "h": "10 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:45",
        "i": "18:32",
        "e": false
      },
      {
        "g": "2026-03-31",
        "h": "11 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:44",
        "i": "18:32",
        "e": false
      }
    ]
  },
  "quetta": {
    "cityKey": "quetta",
    "cityName": "Quetta",
    "timezone": "Asia/Karachi",
    "days": [
      {
        "g": "2026-02-19",
        "h": "1 Ramadan",
        "r": 1,
        "a": 1,
        "s": "05:48",
        "i": "18:23",
        "e": false
      },
      {
        "g": "2026-02-20",
        "h": "2 Ramadan",
        "r": 2,
        "a": 1,
        "s": "05:48",
        "i": "18:24",
        "e": false
      },
      {
        "g": "2026-02-21",
        "h": "3 Ramadan",
        "r": 3,
        "a": 1,
        "s": "05:47",
        "i": "18:25",
        "e": false
      },
      {
        "g": "2026-02-22",
        "h": "4 Ramadan",
        "r": 4,
        "a": 1,
        "s": "05:46",
        "i": "18:26",
        "e": false
      },
      {
        "g": "2026-02-23",
        "h": "5 Ramadan",
        "r": 5,
        "a": 1,
        "s": "05:45",
        "i": "18:26",
        "e": false
      },
      {
        "g": "2026-02-24",
        "h": "6 Ramadan",
        "r": 6,
        "a": 1,
        "s": "05:44",
        "i": "18:27",
        "e": false
      },
      {
        "g": "2026-02-25",
        "h": "7 Ramadan",
        "r": 7,
        "a": 1,
        "s": "05:43",
        "i": "18:28",
        "e": false
      },
      {
        "g": "2026-02-26",
        "h": "8 Ramadan",
        "r": 8,
        "a": 1,
        "s": "05:42",
        "i": "18:29",
        "e": false
      },
      {
        "g": "2026-02-27",
        "h": "9 Ramadan",
        "r": 9,
        "a": 1,
        "s": "05:41",
        "i": "18:29",
        "e": false
      },
      {
        "g": "2026-02-28",
        "h": "10 Ramadan",
        "r": 10,
        "a": 1,
        "s": "05:40",
        "i": "18:30",
        "e": false
      },
      {
        "g": "2026-03-01",
        "h": "11 Ramadan",
        "r": 11,
        "a": 2,
        "s": "05:39",
        "i": "18:31",
        "e": false
      },
      {
        "g": "2026-03-02",
        "h": "12 Ramadan",
        "r": 12,
        "a": 2,
        "s": "05:38",
        "i": "18:31",
        "e": false
      },
      {
        "g": "2026-03-03",
        "h": "13 Ramadan",
        "r": 13,
        "a": 2,
        "s": "05:37",
        "i": "18:32",
        "e": false
      },
      {
        "g": "2026-03-04",
        "h": "14 Ramadan",
        "r": 14,
        "a": 2,
        "s": "05:36",
        "i": "18:33",
        "e": false
      },
      {
        "g": "2026-03-05",
        "h": "15 Ramadan",
        "r": 15,
        "a": 2,
        "s": "05:34",
        "i": "18:34",
        "e": false
      },
      {
        "g": "2026-03-06",
        "h": "16 Ramadan",
        "r": 16,
        "a": 2,
        "s": "05:33",
        "i": "18:34",
        "e": false
      },
      {
        "g": "2026-03-07",
        "h": "17 Ramadan",
        "r": 17,
        "a": 2,
        "s": "05:32",
        "i": "18:35",
        "e": false
      },
      {
        "g": "2026-03-08",
        "h": "18 Ramadan",
        "r": 18,
        "a": 2,
        "s": "05:31",
        "i": "18:36",
        "e": false
      },
      {
        "g": "2026-03-09",
        "h": "19 Ramadan",
        "r": 19,
        "a": 2,
        "s": "05:30",
        "i": "18:36",
        "e": false
      },
      {
        "g": "2026-03-10",
        "h": "20 Ramadan",
        "r": 20,
        "a": 2,
        "s": "05:29",
        "i": "18:37",
        "e": false
      },
      {
        "g": "2026-03-11",
        "h": "21 Ramadan",
        "r": 21,
        "a": 3,
        "s": "05:28",
        "i": "18:38",
        "e": false
      },
      {
        "g": "2026-03-12",
        "h": "22 Ramadan",
        "r": 22,
        "a": 3,
        "s": "05:26",
        "i": "18:38",
        "e": false
      },
      {
        "g": "2026-03-13",
        "h": "23 Ramadan",
        "r": 23,
        "a": 3,
        "s": "05:25",
        "i": "18:39",
        "e": false
      },
      {
        "g": "2026-03-14",
        "h": "24 Ramadan",
        "r": 24,
        "a": 3,
        "s": "05:24",
        "i": "18:39",
        "e": false
      },
      {
        "g": "2026-03-15",
        "h": "25 Ramadan",
        "r": 25,
        "a": 3,
        "s": "05:23",
        "i": "18:40",
        "e": false
      },
      {
        "g": "2026-03-16",
        "h": "26 Ramadan",
        "r": 26,
        "a": 3,
        "s": "05:21",
        "i": "18:41",
        "e": false
      },
      {
        "g": "2026-03-17",
        "h": "27 Ramadan",
        "r": 27,
        "a": 3,
        "s": "05:20",
        "i": "18:41",
        "e": false
      },
      {
        "g": "2026-03-18",
        "h": "28 Ramadan",
        "r": 28,
        "a": 3,
        "s": "05:19",
        "i": "18:42",
        "e": false
      },
      {
        "g": "2026-03-19",
        "h": "29 Ramadan",
        "r": 29,
        "a": 3,
        "s": "05:18",
        "i": "18:43",
        "e": false
      },
      {
        "g": "2026-03-20",
        "h": "30 Ramadan",
        "r": 30,
        "a": 3,
        "s": "05:16",
        "i": "18:43",
        "e": false
      },
      {
        "g": "2026-03-21",
        "h": "1 Shawwal",
        "r": 0,
        "a": 0,
        "s": "05:15",
        "i": "18:44",
        "e": true
      },
      {
        "g": "2026-03-22",
        "h": "2 Shawwal",
        "r": 0,
        "a": 0,
        "s": "05:14",
        "i": "18:45",
        "e": false
      },
      {
        "g": "2026-03-23",
        "h": "3 Shawwal",
        "r": 0,
        "a": 0,
        "s": "05:13",
        "i": "18:45",
        "e": false
      },
      {
        "g": "2026-03-24",
        "h": "4 Shawwal",
        "r": 0,
        "a": 0,
        "s": "05:11",
        "i": "18:46",
        "e": false
      },
      {
        "g": "2026-03-25",
        "h": "5 Shawwal",
        "r": 0,
        "a": 0,
        "s": "05:10",
        "i": "18:46",
        "e": false
      },
      {
        "g": "2026-03-26",
        "h": "6 Shawwal",
        "r": 0,
        "a": 0,
        "s": "05:09",
        "i": "18:47",
        "e": false
      },
      {
        "g": "2026-03-27",
        "h": "7 Shawwal",
        "r": 0,
        "a": 0,
        "s": "05:07",
        "i": "18:48",
        "e": false
      },
      {
        "g": "2026-03-28",
        "h": "8 Shawwal",
        "r": 0,
        "a": 0,
        "s": "05:06",
        "i": "18:48",
        "e": false
      },
      {
        "g": "2026-03-29",
        "h": "9 Shawwal",
        "r": 0,
        "a": 0,
        "s": "05:05",
        "i": "18:49",
        "e": false
      },
      {
        "g": "2026-03-30",
        "h": "10 Shawwal",
        "r": 0,
        "a": 0,
        "s": "05:03",
        "i": "18:49",
        "e": false
      },
      {
        "g": "2026-03-31",
        "h": "11 Shawwal",
        "r": 0,
        "a": 0,
        "s": "05:02",
        "i": "18:50",
        "e": false
      }
    ]
  },
  "gilgit": {
    "cityKey": "gilgit",
    "cityName": "Gilgit",
    "timezone": "Asia/Karachi",
    "days": [
      {
        "g": "2026-02-19",
        "h": "1 Ramadan",
        "r": 1,
        "a": 1,
        "s": "05:20",
        "i": "17:48",
        "e": false
      },
      {
        "g": "2026-02-20",
        "h": "2 Ramadan",
        "r": 2,
        "a": 1,
        "s": "05:19",
        "i": "17:49",
        "e": false
      },
      {
        "g": "2026-02-21",
        "h": "3 Ramadan",
        "r": 3,
        "a": 1,
        "s": "05:18",
        "i": "17:50",
        "e": false
      },
      {
        "g": "2026-02-22",
        "h": "4 Ramadan",
        "r": 4,
        "a": 1,
        "s": "05:17",
        "i": "17:51",
        "e": false
      },
      {
        "g": "2026-02-23",
        "h": "5 Ramadan",
        "r": 5,
        "a": 1,
        "s": "05:16",
        "i": "17:52",
        "e": false
      },
      {
        "g": "2026-02-24",
        "h": "6 Ramadan",
        "r": 6,
        "a": 1,
        "s": "05:14",
        "i": "17:53",
        "e": false
      },
      {
        "g": "2026-02-25",
        "h": "7 Ramadan",
        "r": 7,
        "a": 1,
        "s": "05:13",
        "i": "17:54",
        "e": false
      },
      {
        "g": "2026-02-26",
        "h": "8 Ramadan",
        "r": 8,
        "a": 1,
        "s": "05:12",
        "i": "17:55",
        "e": false
      },
      {
        "g": "2026-02-27",
        "h": "9 Ramadan",
        "r": 9,
        "a": 1,
        "s": "05:11",
        "i": "17:55",
        "e": false
      },
      {
        "g": "2026-02-28",
        "h": "10 Ramadan",
        "r": 10,
        "a": 1,
        "s": "05:09",
        "i": "17:56",
        "e": false
      },
      {
        "g": "2026-03-01",
        "h": "11 Ramadan",
        "r": 11,
        "a": 2,
        "s": "05:08",
        "i": "17:57",
        "e": false
      },
      {
        "g": "2026-03-02",
        "h": "12 Ramadan",
        "r": 12,
        "a": 2,
        "s": "05:07",
        "i": "17:58",
        "e": false
      },
      {
        "g": "2026-03-03",
        "h": "13 Ramadan",
        "r": 13,
        "a": 2,
        "s": "05:06",
        "i": "17:59",
        "e": false
      },
      {
        "g": "2026-03-04",
        "h": "14 Ramadan",
        "r": 14,
        "a": 2,
        "s": "05:04",
        "i": "18:00",
        "e": false
      },
      {
        "g": "2026-03-05",
        "h": "15 Ramadan",
        "r": 15,
        "a": 2,
        "s": "05:03",
        "i": "18:01",
        "e": false
      },
      {
        "g": "2026-03-06",
        "h": "16 Ramadan",
        "r": 16,
        "a": 2,
        "s": "05:02",
        "i": "18:02",
        "e": false
      },
      {
        "g": "2026-03-07",
        "h": "17 Ramadan",
        "r": 17,
        "a": 2,
        "s": "05:00",
        "i": "18:03",
        "e": false
      },
      {
        "g": "2026-03-08",
        "h": "18 Ramadan",
        "r": 18,
        "a": 2,
        "s": "04:59",
        "i": "18:04",
        "e": false
      },
      {
        "g": "2026-03-09",
        "h": "19 Ramadan",
        "r": 19,
        "a": 2,
        "s": "04:57",
        "i": "18:05",
        "e": false
      },
      {
        "g": "2026-03-10",
        "h": "20 Ramadan",
        "r": 20,
        "a": 2,
        "s": "04:56",
        "i": "18:05",
        "e": false
      },
      {
        "g": "2026-03-11",
        "h": "21 Ramadan",
        "r": 21,
        "a": 3,
        "s": "04:55",
        "i": "18:06",
        "e": false
      },
      {
        "g": "2026-03-12",
        "h": "22 Ramadan",
        "r": 22,
        "a": 3,
        "s": "04:53",
        "i": "18:07",
        "e": false
      },
      {
        "g": "2026-03-13",
        "h": "23 Ramadan",
        "r": 23,
        "a": 3,
        "s": "04:52",
        "i": "18:08",
        "e": false
      },
      {
        "g": "2026-03-14",
        "h": "24 Ramadan",
        "r": 24,
        "a": 3,
        "s": "04:50",
        "i": "18:09",
        "e": false
      },
      {
        "g": "2026-03-15",
        "h": "25 Ramadan",
        "r": 25,
        "a": 3,
        "s": "04:49",
        "i": "18:10",
        "e": false
      },
      {
        "g": "2026-03-16",
        "h": "26 Ramadan",
        "r": 26,
        "a": 3,
        "s": "04:47",
        "i": "18:11",
        "e": false
      },
      {
        "g": "2026-03-17",
        "h": "27 Ramadan",
        "r": 27,
        "a": 3,
        "s": "04:46",
        "i": "18:12",
        "e": false
      },
      {
        "g": "2026-03-18",
        "h": "28 Ramadan",
        "r": 28,
        "a": 3,
        "s": "04:44",
        "i": "18:12",
        "e": false
      },
      {
        "g": "2026-03-19",
        "h": "29 Ramadan",
        "r": 29,
        "a": 3,
        "s": "04:43",
        "i": "18:13",
        "e": false
      },
      {
        "g": "2026-03-20",
        "h": "30 Ramadan",
        "r": 30,
        "a": 3,
        "s": "04:41",
        "i": "18:14",
        "e": false
      },
      {
        "g": "2026-03-21",
        "h": "1 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:40",
        "i": "18:15",
        "e": true
      },
      {
        "g": "2026-03-22",
        "h": "2 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:38",
        "i": "18:16",
        "e": false
      },
      {
        "g": "2026-03-23",
        "h": "3 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:37",
        "i": "18:17",
        "e": false
      },
      {
        "g": "2026-03-24",
        "h": "4 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:35",
        "i": "18:18",
        "e": false
      },
      {
        "g": "2026-03-25",
        "h": "5 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:34",
        "i": "18:18",
        "e": false
      },
      {
        "g": "2026-03-26",
        "h": "6 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:32",
        "i": "18:19",
        "e": false
      },
      {
        "g": "2026-03-27",
        "h": "7 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:30",
        "i": "18:20",
        "e": false
      },
      {
        "g": "2026-03-28",
        "h": "8 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:29",
        "i": "18:21",
        "e": false
      },
      {
        "g": "2026-03-29",
        "h": "9 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:27",
        "i": "18:22",
        "e": false
      },
      {
        "g": "2026-03-30",
        "h": "10 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:26",
        "i": "18:23",
        "e": false
      },
      {
        "g": "2026-03-31",
        "h": "11 Shawwal",
        "r": 0,
        "a": 0,
        "s": "04:24",
        "i": "18:23",
        "e": false
      }
    ]
  }
} as const;
